import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import Chapter from './pages/Chapter';
import DashboardAdmin from './pages/DashboardAdmin';
import CreateChapter from './pages/CreateChapter';
import ManageContent from './pages/ManageContent';
import ManageUsers from './pages/ManageUsers';
import Profile from './pages/Profile';
import Tutoring from './pages/Tutoring';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/chapter/:id"
            element={
              <PrivateRoute>
                <Chapter />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/dashboard"
            element={
              <PrivateRoute>
                <DashboardAdmin />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin-master/create-chapter"
            element={
              <PrivateRoute roles={['admin_master']}>
                <CreateChapter />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin-master/manage-content"
            element={
              <PrivateRoute roles={['admin_master']}>
                <ManageContent />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin-master/manage-users"
            element={
              <PrivateRoute roles={['admin_master']}>
                <ManageUsers />
              </PrivateRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <Profile />
              </PrivateRoute>
            }
          />
          <Route
            path="/tutoria"
            element={
              <PrivateRoute>
                <Tutoring />
              </PrivateRoute>
            }
          />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;


